import { Link } from 'react-router-dom';

import StatusChip from '@sayyesschool/frontend/components/status-chip';
import { RequestStatusLabel } from '@sayyesschool/frontend/features/requests';
import { useSetting } from '@sayyesschool/frontend/features/settings';
import { Avatar, Flex, List, ListItem, Text } from '@sayyesschool/frontend/ui-components';

export default function RequestsList({ requests }) {
    const [requestTypes = {}] = useSetting('request.types');

    return (
        <List className="RequestsList">
            {requests?.map(request =>
                <ListItem
                    key={request.id}
                    as={Link}
                    to={request.url}
                    content={
                        <Flex gap="sm">
                            <StatusChip
                                status={request.status}
                                content={RequestStatusLabel[request.status]}
                            />

                            <Text
                                type="body-md"
                                content={requestTypes[request.type]}
                                end={
                                    <Text
                                        content={request.dateTimeString}
                                        type="body-sm"
                                        inline
                                    />
                                }
                                noWrap
                            />

                            {request.contact &&
                                <Text
                                    type="body-sm"
                                    noWrap
                                >
                                    {request.contact.name} · {request.contact.phone || request.contact.email}
                                </Text>
                            }
                        </Flex>
                    }
                    endAction={request.manager &&
                        <Avatar
                            text={request.manager.initials}
                            imageUrl={request.manager?.imageUrl}
                            size="sm"
                        />
                    }
                />
            )}
        </List>
    );
}